<template>
  <div class="unit-not-expanded">
    <div class="unit-img" :style="{
          backgroundImage: `url(${unit.images[0]})`,
        }">
    </div>
    <div class="unit-name-price-container">
      <span class="unit-label">{{ unit.make }} {{ unit.model }}</span>
      <span class="unit-price">{{ formatCurrency(unit.price) }}</span>
    </div>
    <div v-if="interested" style="display: flex; align-items: center;">
      <img src="../assets/check_mark.svg" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  unit: { type: Object || null },
  interested: { type: Boolean }
});

/**
 * Add $ and , to currency value
 * @param {number} value
 */
 function formatCurrency(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
}
</script>

<style>
.unit-not-expanded {
  display: flex;
  padding: 5px 15px 5px 5px;
  border-radius: 8px;
  gap: 10px;
  background-color: white;
  margin-left: 10px;
}

.unit-img {
  height: 50px;
  width: 50px;
  border-radius: 4px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: white;
}

.unit-name-price-container {
  width: 100px;
  height: 46px;
  display: flex;
  flex-direction: column;
  position: unset;
  padding: unset;
  overflow: hidden;
  color: var(--black-default);
  text-align: left;
  align-items: start;

  .unit-label {
    font-size: 13px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0.01em;
  }

  .unit-price {
    font-size: 13px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0.01em;
  }
}
</style>